import { render } from "./illuminationControllerDali.vue?vue&type=template&id=3ac1575a&scoped=true"
import script from "./illuminationControllerDali.vue?vue&type=script&lang=js"
export * from "./illuminationControllerDali.vue?vue&type=script&lang=js"

import "./illuminationControllerDali.vue?vue&type=style&index=0&id=3ac1575a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac1575a"]])

export default __exports__